import { MockCard, MockInput, MockSelect, MockButton } from '../../components/mockups/MockUI'
import { MockTable } from '../../components/mockups/MockTable'
import { MockBadge } from '../../components/mockups/MockBadge'

export function AdminAccountsList() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
          Список пользователей
        </h2>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Страница «Аккаунты» (только ADMIN). Управление пользователями: создание, блокировка, смена
          роли.
        </p>
      </div>
      <MockTable
        caption="Пример таблицы аккаунтов"
        columns={[
          { header: 'Имя' },
          { header: 'Email' },
          { header: 'Роль' },
          { header: 'Статус' },
          { header: 'Действия' },
        ]}
        rows={[
          [
            'Иванов Пётр',
            'manager@crm.local',
            <MockBadge color="blue">Менеджер</MockBadge>,
            <MockBadge color="green">Активен</MockBadge>,
            '✎ 🔒',
          ],
          [
            'Ольга К.',
            'procurement@crm.local',
            <MockBadge color="purple">Закупщик</MockBadge>,
            <MockBadge color="green">Активен</MockBadge>,
            '✎ 🔒',
          ],
          [
            'Тестовый',
            'test@crm.local',
            <MockBadge color="blue">Менеджер</MockBadge>,
            <MockBadge color="red">Заблокирован</MockBadge>,
            '✎ 🔓',
          ],
        ]}
      />
      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400 space-y-2">
          <div className="font-medium text-gray-800 dark:text-gray-200">Действия:</div>
          <ul className="list-disc list-inside space-y-1">
            <li>✎ — редактировать (имя, email, роль, пароль)</li>
            <li>🔒 — заблокировать (пользователь не сможет войти)</li>
            <li>🔓 — разблокировать</li>
          </ul>
        </div>
      </MockCard>
    </div>
  )
}

export function AdminAccountsCreate() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
          Создание аккаунта
        </h2>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Кнопка «Создать аккаунт» на странице аккаунтов. Только ADMIN может создавать
          пользователей.
        </p>
      </div>
      <MockCard className="max-w-lg">
        <div className="text-base font-medium text-gray-900 dark:text-gray-100 mb-4">
          Новый аккаунт
        </div>
        <div className="space-y-3">
          <MockInput label="Email *" value="new@crm.local" />
          <MockInput label="Пароль *" value="••••••••" />
          <MockInput label="Имя" value="Новый Сотрудник" />
          <MockSelect label="Роль *" value="MANAGER — Менеджер" />
          <div className="flex gap-2 pt-2">
            <MockButton>Создать</MockButton>
            <MockButton variant="secondary">Отмена</MockButton>
          </div>
        </div>
      </MockCard>
      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400 space-y-2">
          <div className="font-medium text-gray-800 dark:text-gray-200">Роли:</div>
          <ul className="space-y-1 list-none">
            <li>
              <MockBadge color="red">ADMIN</MockBadge> — полный доступ ко всему
            </li>
            <li>
              <MockBadge color="blue">MANAGER</MockBadge> — свои клиенты и заявки, КП
            </li>
            <li>
              <MockBadge color="purple">PROCUREMENT</MockBadge> — очередь закупки, квоты
            </li>
            <li>
              <MockBadge color="orange">РОП</MockBadge> — руководитель отдела продаж: всё что
              менеджер + контроль команды по городам
            </li>
            <li>
              <MockBadge color="green">РОЗ</MockBadge> — руководитель отдела закупок: всё что
              закупщик + агрегат команды по городам
            </li>
          </ul>
          <p className="mt-2">Подробнее про РОП и РОЗ — в разделе «Роли и доступ».</p>
        </div>
      </MockCard>
    </div>
  )
}

export function AdminRatesEdit() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">Курсы валют</h2>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Страница «Курс валют» (только ADMIN). Три карточки с текущими курсами USD, EUR, CNY к
          рублю.
        </p>
      </div>
      <div className="grid grid-cols-3 gap-3">
        <MockCard className="text-center">
          <div className="text-lg font-bold text-green-600">$ 92.50</div>
          <div className="text-xs text-gray-500 dark:text-gray-400 mt-1">USD</div>
        </MockCard>
        <MockCard className="text-center">
          <div className="text-lg font-bold text-blue-600">€ 100.20</div>
          <div className="text-xs text-gray-500 dark:text-gray-400 mt-1">EUR</div>
        </MockCard>
        <MockCard className="text-center">
          <div className="text-lg font-bold text-red-600">¥ 12.80</div>
          <div className="text-xs text-gray-500 dark:text-gray-400 mt-1">CNY</div>
        </MockCard>
      </div>
      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400">
          Кликните на карточку — откроется поле ввода нового курса. Нажмите «Сохранить». Курсы
          отображаются в сайдбаре внизу (строка под меню) для всех пользователей. Используются при
          пересчёте цен в рубли для КП.
        </div>
      </MockCard>
    </div>
  )
}

export function AdminRatesMarkup() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
          Константы наценки
        </h2>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Ниже курсов валют — таблица коэффициентов наценки по матрицам.
        </p>
      </div>
      <MockTable
        caption="Настройка наценок"
        columns={[
          { header: 'Склад' },
          { header: 'Китай' },
          { header: 'РФ' },
          { header: 'Производители' },
          { header: 'Стоки' },
        ]}
        rows={[['×1.35', '×1.40', '×1.30', '×1.45', '×1.25']]}
      />
      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400">
          Каждое значение — поле ввода. После изменения нажмите «Сохранить константы». Коэффициент
          применяется при создании квоты (поле{' '}
          <span className="font-mono text-xs">priceWithCoeff</span>) и при формировании КП.
        </div>
      </MockCard>
    </div>
  )
}

export function AdminCatalogOverview() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
          Каталог партномеров
        </h2>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Каталог автоматически пополняется при вводе позиций в заявки. Содержит уникальные пары
          «партномер + бренд» для автоподсказок.
        </p>
      </div>
      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400 space-y-2">
          <div className="font-medium text-gray-800 dark:text-gray-200">Как работает:</div>
          <ul className="list-disc list-inside space-y-1">
            <li>При создании позиции пара (партномер, бренд) сохраняется в каталог</li>
            <li>При следующем вводе того же партномера — бренд подставляется автоматически</li>
            <li>Ключ нормализован (регистронезависимый, без пробелов/дефисов)</li>
            <li>
              Страница <span className="font-mono text-xs">/admin/part-catalog</span> — просмотр и
              импорт
            </li>
          </ul>
        </div>
      </MockCard>
    </div>
  )
}

export function AdminCatalogImport() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
          Импорт каталога
        </h2>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          ADMIN может массово загрузить партномера из Excel-файла.
        </p>
      </div>
      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400 space-y-2">
          <div className="font-medium text-gray-800 dark:text-gray-200">Формат Excel-файла:</div>
          <ul className="list-disc list-inside space-y-1">
            <li>Столбец A — партномер</li>
            <li>Столбец B — бренд</li>
            <li>Первая строка — заголовки (пропускается)</li>
          </ul>
          <div className="font-medium text-gray-800 dark:text-gray-200 mt-3">Процесс:</div>
          <ol className="list-decimal list-inside space-y-1">
            <li>Нажмите «Импорт Excel» на странице каталога</li>
            <li>Выберите .xlsx файл</li>
            <li>Система загрузит все пары, дубликаты пропускаются автоматически</li>
            <li>Результат: «Добавлено 1234 из 5000 (дубликатов: 3766)»</li>
          </ol>
        </div>
      </MockCard>
    </div>
  )
}
